import { EntityListImportStep, setImportStepRunning } from '../entityListAdministrationSlice';
import { useCallback } from 'react';
import { useAppDispatch } from '../../../../store';
import { EntityListTypeSupported } from '../entityListsLib';

type SetImportStepRunningCallback = (
  step: EntityListImportStep,
  isCurrentlyRunning: boolean,
) => void;

/**
 * Returns a function to set if the given import step is currently running or not
 * @param entityListType type of entity list to work with
 */
export const useSetImportStepRunning = (
  entityListType: EntityListTypeSupported,
): SetImportStepRunningCallback => {
  const dispatch = useAppDispatch();

  return useCallback(
    (step: EntityListImportStep, isCurrentlyRunning: boolean) => {
      dispatch(
        setImportStepRunning({
          entityListType,
          data: {
            step: step,
            value: isCurrentlyRunning,
          },
        }),
      );
    },
    [dispatch, entityListType],
  );
};
